module.exports = __webpack_public_path__ + "static/proj1hero-65696c4ed7c00db23df40eae1cec0a91.png";